<script setup>
import { PopoverAnchor } from 'radix-vue'

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
})
</script>

<template>
    <PopoverAnchor v-bind="props">
        <slot />
    </PopoverAnchor>
</template>
